export default {"src":"/_next/static/media/loading.111df02d.svg","height":30,"width":120};